import { z } from 'zod';
export const samlAttributeMappingGuard = z.record(z.string());
export var BindingType;
(function (BindingType) {
    BindingType["Post"] = "urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST";
    BindingType["Redirect"] = "urn:oasis:names:tc:SAML:2.0:bindings:HTTP-Redirect";
})(BindingType || (BindingType = {}));
export const samlAcsUrlGuard = z.object({
    binding: z.nativeEnum(BindingType),
    url: z.string().url(),
});
